import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import SvgIcon from 'Components/SvgIcon'
import { MODAL_TYPE } from 'Defaults/modals'
import { FAVOURITE_TYPES } from 'Defaults/favourites'


import {
  _FavouritesSectionContainer,
  _FavouriteTag,
  _EditButtonContainer,
  _SectionContainer,
  _NoteContainer,
  _TagsContainer,
  _AddFavouritesBtn,
} from './styles'


const FavouritesSection = ({
  item,
  openEditFavouritesModal,
  modelType,
  isBuilding,
  isArchived,
  userFavListings = {},
  userFavBuildings = {},
}) => {
  const [favouriteTagsNote, setFavouriteTagsNote] = useState()
  const {
    id: modelId,
    mls_number: mlsNumber,
    home_type: homeType = null,
    property_class: propertyClass = null,
    offer = null,
  } = item || {}
  useEffect(() => {
    if(modelType === FAVOURITE_TYPES.BUILDING) setFavouriteTagsNote(userFavBuildings?.[modelId] || null)
    else setFavouriteTagsNote(userFavListings?.[mlsNumber] || null)
  }, [modelType, modelId, mlsNumber, userFavBuildings, userFavListings])

  const tagsNoteExist =
   (favouriteTagsNote?.note && favouriteTagsNote?.note.trim() !== '') || favouriteTagsNote?.tags?.length > 0

  const openFavouritesHandler = (e) => {
    const gaSource = isBuilding ? 'Building card tile footer' : 'Listing card tile footer'
    e.preventDefault()
    e.stopPropagation()
    openEditFavouritesModal({
      modalType: MODAL_TYPE.EDIT_FAVOURITES,
      modalData: {
        modelId,
        modelType,
        isBuilding,
        mlsNumber,
        existingTags: favouriteTagsNote?.tags,
        existingNote: favouriteTagsNote?.note,
        homeType,
        propertyClass,
        isArchived,
        offerType: offer,
        gaSource,
      },
      modalSource: 'Favourites',
    })
  }

  return (
    tagsNoteExist ? (
      <_FavouritesSectionContainer>
        <_SectionContainer>
          {favouriteTagsNote?.note &&
            <_NoteContainer>&quot;{favouriteTagsNote.note}&quot;</_NoteContainer>}
          {favouriteTagsNote?.tags?.length > 0 &&
            <_TagsContainer>
              {favouriteTagsNote.tags.map(tag => (
                <_FavouriteTag
                  key={tag}
                >
                  {tag}
                </_FavouriteTag>
              ))}
            </_TagsContainer>
          }
        </_SectionContainer>

        <_EditButtonContainer onClick={openFavouritesHandler}>
          <SvgIcon name="#icon-edit-material" width={20} height={20} tootltip="edit" />
          edit
        </_EditButtonContainer>
      </_FavouritesSectionContainer>
    ) :
      <_FavouritesSectionContainer>
        <_AddFavouritesBtn medium secondary onClick={openFavouritesHandler}>Add notes and tags</_AddFavouritesBtn>
      </_FavouritesSectionContainer>
  )
}

const favouriteObjectPropType = PropTypes.shape({
  note: PropTypes.string,
  tags: PropTypes.arrayOf(PropTypes.string),
})

FavouritesSection.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.number,
    mls_number: PropTypes.string,
    home_type: PropTypes.string,
    property_class: PropTypes.string,
    offer: PropTypes.string,
  }),
  isBuilding: PropTypes.bool,
  modelType: PropTypes.string,
  userFavListings: PropTypes.shape(favouriteObjectPropType),
  userFavBuildings: PropTypes.shape(favouriteObjectPropType),
  openEditFavouritesModal: PropTypes.func,
  isArchived: PropTypes.bool,
}

export default FavouritesSection
